import { handleDownloadDPSSHJParentsAgreement } from "hooks/downloads";
import {
  handleDownloadDPSRAKRoutes,
  handleDownloadDPSSHJSNRRoutes,
  handleDownloadDPSSHJPRIRoutes,
  handleDownloadDPSSHJSNRDD,
  handleDownloadDPSSHJPRIDD,
  handleDownloadTraAgrFormRAK,
  handleDownloadTraAgrForm,
  handleDownloadASBT,
  handleDownloadNBT,
  handleDownloadSTAFFASBT,
  handleDownloadSTAFFNBT,
  handleDownloadDPSRAKDRIVERDETAILS,
} from "hooks/downloads";

export const navConfigDrawer = [
  {
    title: "About Us",
    path: "/about-us",
  },

  {
    title: "Our Services",
    path: "/services/service-summary",
  },

  {
    title: "Bus Route DPS Sharjah Primary",
    // action: handleDownloadDPSSHJPRIRoutes,
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FBUS-ROUTES-DPS-SHARJAH-primary25-06-10.pdf?alt=media&token=53123b4a-a4c1-4e8c-ba88-f1701989ed73",
  },
  {
    title: "Bus Route DPS Sharjah Senior",
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FBUS-ROUTES-DPS-SHARJAH-senior-25-06-10.pdf?alt=media&token=dc3490b2-6987-4b37-bb3e-d03386a64076",
  },
  {
    title: "Bus Route DPS RAK",
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2Fdps-rak-bus-routes4.pdf?alt=media&token=81adc8b1-c8dc-46c7-829a-704990ee17b3",
  },

  {
    title: "Driver Details DPS Sharjah Primary",
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FDRIVER-DETAILS-DPS-PRIMARY5Update.pdf?alt=media&token=b76ec85a-62e6-4ac5-863a-d62bd288292a",
  },
  {
    title: "Driver Details DPS Sharjah Senior",
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FDRIVER-DETAILS-DPS-SENIOR3.pdf?alt=media&token=f2244a8c-813f-47b7-bde9-669ca5ccd75c",
  },
  {
    title: "Driver Details DPS RAK",
    path: "https://firebasestorage.googleapis.com/v0/b/alsaraya-d8bd7.appspot.com/o/pdf%2FDRIVER-ROUTE-DETAILS-DPS-RAK-AY-25-06-10.pdf?alt=media&token=d35d454c-94af-4edd-9e7a-4b1ca4f052f2",
  },

  {
    title: "Fee Details",
    path: "/fees/details",
  },

  {
    title: "NBT Parents Agreement Form DPS Sharjah Primary",
    // action: handleDownloadTraAgrForm,
    path: "https://firebasestorage.googleapis.com/v0/b/najmat-49083.appspot.com/o/pdf%2Fnbt-transport-agreement.pdf?alt=media&token=7452bcdd-9ea8-43c2-847c-a1f66175c4fa",
  },
  {
    title: "NBT Parents Agreement Form DPS Sharjah Senior",
    // action: handleDownloadTraAgrForm,
    path: "https://firebasestorage.googleapis.com/v0/b/najmat-49083.appspot.com/o/pdf%2Fnbt-transport-agreement.pdf?alt=media&token=7452bcdd-9ea8-43c2-847c-a1f66175c4fa",
  },
  {
    title: "NBT Parents Agreement Form DPS RAK",
    // action: handleDownloadTraAgrFormRAK,
    path: "https://firebasestorage.googleapis.com/v0/b/najmat-49083.appspot.com/o/pdf%2Fnbt-transport-agreement.pdf?alt=media&token=7452bcdd-9ea8-43c2-847c-a1f66175c4fa",
  },
  {
    title: "Payment Details",
    path: "/fees/payment-modes",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navConfig = [
  {
    title: "About Us",
    path: "/about-us",
  },
  {
    title: "Services",
    path: "/services",
    children: [
      {
        title: "Our Services",
        path: "/services/service-summary",
      },
      {
        title: "Bus Route Details",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadDPSSHJPRIRoutes,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRRoutes,
          },
          {
            title: "DPS RAK",
            action: handleDownloadDPSRAKRoutes,
          },
        ],
      },
      {
        title: "Driver Details Download",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadDPSSHJPRIDD,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadDPSSHJSNRDD,
          },
          {
            title: "DPS RAK",
            action: handleDownloadDPSRAKDRIVERDETAILS,
          },
        ],
      },
    ],
  },
  {
    title: "Fees",
    path: "/fees",
    children: [
      {
        title: "Fee Details",
        path: "/fees/details",
      },
      {
        title: "NBT Parents Agreement Form",
        path: "",
        children: [
          {
            title: "DPS Sharjah Primary",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS Sharjah Senior",
            action: handleDownloadTraAgrForm,
          },
          {
            title: "DPS RAK",
            action: handleDownloadTraAgrFormRAK,
          },
        ],
      },
      {
        title: "Payment Details",
        path: "/fees/payment-modes",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const navconfigNew = (navigate) => {
  return [
    {
      label: "Home",
      path: "/",
    },
    {
      label: "Our Services",
      path: "/services",
      items: [
        {
          label: "School transportation",
          path: "/transport",
          callback: () => navigate("/services/transport"),
        },
        {
          label: "Vehicle Maintenance",
          path: "/maintance",
          callback: () => navigate("/services/maintenance"),
        },
      ],
    },
    {
      label: "Bus Routes",
      path: "",
      items: [
        {
          label: "DPS Sharjah",
          items: [
            { label: "Primary Section", callback: handleDownloadDPSSHJPRIRoutes },
            { label: "Senior Section", callback: handleDownloadDPSSHJSNRRoutes },
          ],
        },
        {
          label: "DPS RAK",
          callback: handleDownloadDPSRAKRoutes,
        },
        {
          label: "Driver Details",
          items: [
            {
              label: "DPS Sharjah",
              items: [
                { label: "Primary Section", callback: handleDownloadDPSSHJPRIDD },
                { label: "Senior Section", callback: handleDownloadDPSSHJSNRDD },
              ],
            },
            {
              label: "DPS RAK",
              callback: handleDownloadDPSRAKDRIVERDETAILS,
            },
          ],
        },
        {
          label: "FAQs",
          path: "/faq/logistics",
          callback: () => navigate("/faq/logistics"),
        },
      ],
    },
    {
      label: "Forms",
      path: "",
      items: [
        {
          label: "Transport form - NBT",
          callback: handleDownloadNBT,
        },
        {
          label: "Transport form for staff - NBT",
          callback: handleDownloadSTAFFNBT,
        },
      ],
    },
    {
      label: "Fees",
      path: "/fees",
      items: [
        {
          label: "DPS Sharjah",
          path: "/fees/dps-sharjah",
          callback: () => navigate("/fees/dps-sharjah"),
        },
        {
          label: "DPS RAK",
          path: "/fees/dps-rak",
          callback: () => navigate("/fees/dps-rak"),
        },
        {
          label: "NBT Parents Agreement Form",
          callback: handleDownloadDPSSHJParentsAgreement,
        },
        {
          label: "FAQs",
          path: "/faq/fees",
          callback: () => navigate("/faq/fees"),
        },
      ],
    },
    {
      label: "Careers",
      path: "/careers/list",
      callback: () => navigate("/careers/list"),
    },
  ];
};
